/**
 * @file src/const/roles.ts
 * @exports RoleEnum
 * @exports roleData
 * @summary Role labels, descriptions, and enum values used for Cognition permission checks.
 */
export const roleData = {
	superAdmin: {
		name: "Super Admin",
		description:
			"Super Admins may add, configure, and edit organizations, suborganizations, and users. They may also process orders.",
	},
	admin: {
		name: "Organization Admin",
		description:
			"Organization Admins have limited access to organization-level controls. They may add/edit users and process orders.",
	},
	user: {
		name: "User",
		description: "Users can submit orders.",
	},
	integrationAdmin: {
		name: "Integration Admin",
		description:
			"Integration Admins have the same access controls as Organization Admins, but can view unmasked PII data",
	},
	cerebrumTeam: {
		name: "Cerebrum Team",
		description:
			"Cerebrum Team has unrestricted read access to some entities in the system. Kind of like super processor.",
	},
	processor: {
		name: "Processor",
		description: "Processors can view and process orders for affiliate organizations",
	},
	limitedProcessor: {
		name: "Limited Processor",
	},
	tazIntegration: {
		name: "TazWorks API Integration",
		description:
			"This role is used to integrate with TazWorks API. It has unrestricted read access to packages and can read organizations, invites, and vouchers that are linked to TazWorks.",
	},
};

export enum RoleEnum {
	CraAdmin = "CRA_ADMIN",
	IntegrationAdmin = "INTEGRATION_ADMIN",
	LimitedProcessor = "LIMITED_PROCESSOR",
	OrganizationAdmin = "ORGANIZATION_ADMIN",
	Processor = "PROCESSOR",
	CerebrumTeam = "CEREBRUM_TEAM",
	SuperAdmin = "SUPER_ADMIN",
	TazIntegration = "TAZ_INTEGRATION",
	User = "USER",
}
